<template>
  <div class="orderDialogBox">
    <span class="blueTitle">{{ title }}</span>
    <slot name="content"></slot>
  </div>

</template>

<script>
export default {
  name: "OrderDialogBox",
  props: {
    title: String
  }
}
</script>

<style lang="less">
.orderDialogBox {
  margin: 5px 0;
  padding: 5px;
  border: solid 1px #949494;

  .blueTitle {
    padding: 5px 0;
    display: block;
    min-width: 70px;
    font-size: 17px !important;
    font-weight: bold;
    border-bottom: solid 1px #aaaaaa;
  }
}
</style>